import { useToast } from 'vue-toastification';

const toast = useToast();

// initial state
const state = () => ({
    currentUser: null,
})

// getters
// const getters = {
//     currentUser: state => state.currentUser
// }

// actions
const actions = {
    login: async ({ commit }, user) => {
        // console.log('auth action user:', user);
        await axios.get('sanctum/csrf-cookie').then(() => {
            return axios.post('/login', {
                email: user.email,
                password: user.password,
                remember: user.remember
            }).then(({ data }) => {
                commit('setCurrentUser', data);
                return true;
            }).catch(({ response }) => {
                toast.error(response.data.message);
                throw response.data;
            });
        });
    },

    register: async ({ commit }, user) => {
        // console.log('auth action user:', user);
        await axios.get('sanctum/csrf-cookie').then(() => {
            return axios.post('/register', {
                email: user.email,
                password: user.password,
                password_confirmation: user.password_confirmation
            }).then(({ data }) => {
                commit('setCurrentUser', data);
                return true;
            }).catch(({ response }) => {
                toast.error(response.data.message);
                throw response.data;
            });
        });
    },

    getCurrentUser: async ({ commit, state }, payload) => {
        // console.log('getCurrentUser payload', payload);
        // console.log('existing currentUser state', state.currentUser);
        return axios.get('currentUser').then(({ data }) => {
            // console.log('currentUser data', data);
            if (!data.message) {
                // console.log('set currentUser', data);
                commit('setCurrentUser', data);
                return data;
            } else {
                // console.log('no currentUser data', data);
                // If currentUser state is not empty
                if (this.state.currentUser) {
                    toast.error('Unauthenticated');
                }
                return null;
            }
        }).catch(({ response }) => {
            // toast.error(response.data.message);
            throw response?.data || 'Failed to fetch user data';
        });
    },

    logout: async ({ commit }) => {
        return axios.post('logout').then(() => {
            commit('setCurrentUser', null);
            return true;
        }).catch(({ response }) => {
            toast.error(response.data.message);
            throw response.data;
        });
    },

    forgotPassword: async ({ commit }, email) => {
        // Use the app subdomain
        const URL = import.meta.env.VITE_APP_DOMAIN + '/forgot-password';

        return axios.post(URL, {
            email: email
        }).then((response) => {
            return response;
        }).catch(({ response }) => {
            toast.error(response.data.message);
            throw response.data;
        });
    },

    resetPassword: async ({ commit }, { user, resetToken }) => {
        return axios.post('reset-password', {
            token: resetToken,
            email: user.email,
            password: user.password,
            password_confirmation: user.password_confirmation
        }).then((response) => {
            return response;
        }).catch(({ response }) => {
            toast.error(response.data.message);
            throw response.data;
        });
    }
}

// mutations
const mutations = {
    setCurrentUser(state, payload) {
        state.currentUser = payload;
    }
}

export default {
    namespaced: true,
    state,
    // getters,
    actions,
    mutations
}
